import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";

const Plant = ({ image, name }) => {
  return (
    <div className="powerfulPlant absolute w-28 h-28 md:w-32 md:h-32 bg-white shadow-2xl bg-opacity-30 rounded-full top-0 bottom-0 left-0 right-0 m-auto">
      <GatsbyImage image={image} alt={name} className="p-1 -mt-2 md:mt-0" />
      <p className="text-yellow-dark text-center absolute bottom-6 left-0 right-0">
        <strong>{name}</strong>
      </p>
    </div>
  );
};

export default Plant;
